import styled from 'styled-components';

export const StyledGeneralBuildingData = styled.div`
    flex-basis: 75%;

    .general-data-title {
        font-weight: 700;
        font-size: 20px;
        color: #373647;
        margin-bottom: 24px;
        display: flex;
        gap: 20px;
        align-items: center;
    }

    .stats-cards-wrapper {
        display: flex;
        gap: 16px;
    }
`